/**
 * Площадь текстом с единицей для предложений, где React-элемент `<Area>` в
 * значение сообщения не поставить: единица — строка каталога, а не склейка.
 */
import { defineMessages } from "../../i18n/define";
import { tr } from "../../i18n/runtime";
import { formatArea } from "../../lib/format";

const m = defineMessages({
  haValue: {
    id: "registry.areaText.ha",
    defaultMessage: "{value} га",
    description: "Площадь в гектарах с единицей внутри фразы: «1 234,56 га»; {value} — отформатированное число",
  },
});

/** «1 234,56 га»; пустая площадь — «нет данных», а не ноль. */
export function areaText(microha: number | null | undefined, options: { rounded?: boolean } = {}): string {
  const value = formatArea(microha, options);
  return value.missing ? value.text : tr(m.haValue, { value: value.text });
}
